const o = (e, r, f) => {
  if (typeof e != "object" || e === null)
    return !1;
  for (const [n, t] of Object.entries(e))
    if (n === r && t === f || typeof t == "object" && o(t, r, f))
      return !0;
  return !1;
};
export {
  o as f
};
